import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Box,
  Modal,
  Button,
  colors,
} from "@mui/material";
import { IoMdRadioButtonOn } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdTime } from "react-icons/io";
import { FaBagShopping } from "react-icons/fa6";
import { FaBox } from "react-icons/fa";
import { FaBezierCurve } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { GoSearch } from "react-icons/go";
import { ClosedDelivery } from "../closedDeliveries";
import { ReallotedDelivery } from "../reallotedDeliveries";
import { NewDelivery } from "../newDeliveries";
import { OutforDelivery } from "./outforDelivery";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { axiosInstance } from "../../../axiosInstance";
import { toast } from "react-toastify";

const columns = [
  // { id: "delivery_id", label: "DELIVERY ID", minWidth: 170, align: "center" },
  // { id: "order_id", label: "ORDER ID", minWidth: 170, align: "center" },
  {
    id: "delivery_show_id",
    label: "DELIVERY ID",
    minWidth: 170,
    align: "center",
  },
  { id: "ryder_id", label: "RYDER ID", minWidth: 170, align: "center" },
  {
    id: "pick_up_location",
    label: "PICKUPLOCATION",
    minWidth: 200,
    align: "center",
  },
  {
    id: "drop_location",
    label: "DROP LOCATION",
    minWidth: 170,
    align: "center",
  },
  {
    id: "created_at",
    label: "DELIVERY SLOT TIME",
    minWidth: 170,
    align: "center",
  },
  // { id: "typeofpack", label: "TYPE OF PACK", minWidth: 130, align: "center" },
  // { id: "no_of_pack", label: "NO OF PACKS", minWidth: 130, align: "center" },
  {
    id: "vehicle_type",
    label: "VECHICLE TYPE",
    minWidth: 130,
    align: "center",
  },
  { id: "action", label: "ACTION", minWidth: 130, align: "center" },
];

function createData(
  delivery_id,
  ryder_id,
  pick_up_location,
  drop_location,
  created_at,
  typeofpack,
  no_of_pack,
) {
  return {
    delivery_id,
    ryder_id,
    pick_up_location,
    drop_location,
    created_at,
    typeofpack,
    no_of_pack,
  };
}

// const rows = [
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Bag",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Box",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Bag",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Box",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Bag",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Box",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Bag",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Box",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Bag",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Box",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Bag",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Box",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Bag",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Box",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Bag",
//     "04"
//   ),
//   createData(
//     "#AB1234",
//     "#GMKDP123",
//     "Shiva Sai Agencies",
//     "Vasavi Traders",
//     "10:30-11:00",
//     "Box",
//     "04"
//   ),
// ];

export function InprogressDelivery() {
  const [inprogressDeliveryList, setInprogressDeliveryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [selectedOrderItemId, setSelectedOrderItemId] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(20);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const fetchInProgressDeliverys = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        // "/admin/deliveries/?pickup_status=picked"
        "/admin/deliveries/?pickup_status=pending",
      );
      console.log("✅ In progress Deliverys list response:", res.data);
      if (res.data.status === "success") {
        setInprogressDeliveryList(res.data.data || []);
      } else {
        setError("Failed to fetch In progress Deliverys  data.");
      }
    } catch (err) {
      console.error("❌ Error fetching In progress Deliverys  data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInProgressDeliverys();
  }, []);

  // Re-Allocate API call
  const handleReallocate = async () => {
    if (!selectedOrderItemId) return;
    try {
      const res = await axiosInstance.get(
        `/admin/order-item-changing-reassiging/${selectedOrderItemId}/`,
      );
      if (res.data.status === "success") {
        toast.success("Order re-allocated successfully!");
        navigate("/delivery");
      } else {
        toast.error(res.data.message || "Failed to re-allocate order.");
      }
    } catch (err) {
      console.error("❌ Error re-allocating:", err);
      toast.error("Something went wrong while re-allocating.");
    } finally {
      setOpenModal(false);
    }
  };

  const filteredData = inprogressDeliveryList.filter((row) => {
    const query = searchQuery.toLowerCase();

    const orderIdStr = String(row.order_id ?? "").toLowerCase();
    const ryderIdStr = String(row.ryder_id ?? "").toLowerCase();
    // const deliveryIdStr = String(row.delivery_id ?? "").toLowerCase();
    const deliveryIdStr = String(row.delivery_show_id ?? "").toLowerCase();
    const pickupStr = String(row.pick_up_location ?? "").toLowerCase();
    const dropStr = String(row.drop_location ?? "").toLowerCase();

    return (
      orderIdStr.includes(query) ||
      ryderIdStr.includes(query) ||
      deliveryIdStr.includes(query) ||
      pickupStr.includes(query) ||
      dropStr.includes(query)
    );
  });

  function formatDateTime(dateString) {
    if (!dateString) return "--";

    try {
      // Split date and time
      const [datePart, timePart, meridian] = dateString.split(" ");

      // Extract year, month, day
      const [year, month, day] = datePart.split("-");

      // Return formatted as DD/MM/YYYY HH:MM AM/PM
      return `${day}/${month}/${year} ${timePart} ${meridian}`;
    } catch (error) {
      return "--";
    }
  }

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("reassign_page");
    return savedPage ? Number(savedPage) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = localStorage.getItem("reassign_rowsPerPage");
    return savedRows ? Number(savedRows) : 20;
  });
  const pageChangedByUser = useRef(false);

  const handleChangePage = (event, newPage) => {
    pageChangedByUser.current = true;
    setPage(newPage);
    localStorage.setItem("reassign_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);
    pageChangedByUser.current = true;

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("reassign_rowsPerPage", value);
    localStorage.setItem("reassign_page", 0);
  };

  // Reset page on search and filters

  useEffect(() => {
    if (loading) return;

    // Do NOT reset page on refresh
    if (!pageChangedByUser.current) return;

    const maxPage = Math.max(
      0,
      Math.ceil(filteredData.length / rowsPerPage) - 1,
    );

    if (page > maxPage) {
      setPage(0);
      localStorage.setItem("reassign_page", 0);
    }
  }, [filteredData.length, rowsPerPage, loading, page]);

  return (
    <>
      <div>
        <div className="delivery-top-container">
          <div className="admin-listText">List of In process Deliveries</div>
          {/* <div>
            <select
              className="listAdmin-showRecords"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              <option value={20}>Show No of Records</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={2000}>2000</option>
              <option value={5000}>5000</option>
            </select>
          </div> */}
          <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="btnContainer">
          <button
            style={{
              // backgroundColor: "#FF961F",
              // color: "white",
              // display: "flex",
              backgroundColor: "#E8E8E9",
              color: "black",
              display: "flex",
            }}
            onClick={() => navigate("/out-for-delivery")}
          >
            <FaMapLocationDot style={{ marginRight: "8px" }} />
            Track Your Orders
          </button>
          <button
            // style={{ backgroundColor: "#34C759", color: "white" }}
            style={{ backgroundColor: "#E8E8E9" }}
            onClick={() => navigate("/delivery")}
          >
            Unassigned
          </button>
          <button
            // style={{ backgroundColor: "#FF961F", color: "white" }}
            style={{ backgroundColor: "#1265c5", color: "white" }}
            onClick={() => navigate("/inprogress-delivery")}
          >
            {/* In Process */}
            Re-Assign
          </button>
          <button
            style={{ backgroundColor: "#E8E8E9" }}
            onClick={() => navigate("/closed-delivery")}
          >
            Delivered
          </button>
          {/* <button
          style={{ backgroundColor: "#1265C5", color: "white" }}
          onClick={() => navigate("/realloted-delivery")}
        >
          ReAlloted
        </button> */}
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <Box sx={{ width: "100%", overflowX: "auto" }}>
            <TableContainer
              sx={{
                maxHeight: 640,
                minWidth: 1800,
                overflowX: "auto",
              }}
              className="Table-container"
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : filteredData.length > 0 ? (
                    filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row, index) => (
                        <TableRow
                          key={index}
                          hover
                          className="table-row"
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className="tableCelldata"
                                // onClick={
                                //   column.id === "order_id"
                                //     ? () =>
                                //         navigate(
                                //           `/closed-delivery-details/${row.delivery_id}`
                                //         )
                                //     : undefined
                                // }
                                onClick={
                                  column.id === "delivery_show_id"
                                    ? () =>
                                        navigate(
                                          `/view-deliveryId_wise-reassign/${row.delivery_show_id}`,
                                        )
                                    : undefined
                                }
                                sx={{
                                  cursor:
                                    column.id === "delivery_show_id"
                                      ? "pointer"
                                      : "default",
                                  color:
                                    column.id === "delivery_show_id"
                                      ? "#4184D1"
                                      : "",
                                }}
                              >
                                {column.id === "pick_up_location" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <IoMdRadioButtonOn
                                      style={{
                                        fontSize: "18px",
                                        color: "#34C759",
                                      }}
                                    />
                                    {value || "--"}
                                  </div>
                                ) : column.id === "drop_location" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <FaLocationDot
                                      style={{
                                        fontSize: "18px",
                                        color: "#F52D56",
                                      }}
                                    />
                                    {value || "--"}
                                  </div>
                                ) : column.id === "created_at" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <IoMdTime
                                      style={{
                                        fontSize: "18px",
                                        color: "#FF961F",
                                      }}
                                    />
                                    <span
                                      style={{
                                        border: "1px solid rgb(168, 199, 231)",
                                        padding: "5px",
                                        borderRadius: "5px",
                                      }}
                                    >
                                      {formatDateTime(value) || "--"}
                                    </span>
                                  </div>
                                ) : column.id === "vehicle_type" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    {value === "Bag" ? (
                                      <FaBezierCurve
                                        style={{
                                          fontSize: "18px",
                                          color: "#FF961F",
                                        }}
                                      />
                                    ) : (
                                      <FaBezierCurve
                                        style={{
                                          fontSize: "18px",
                                          color: "#FF961F",
                                        }}
                                      />
                                    )}
                                    {value || "--"}
                                  </div>
                                ) : column.id === "action" ? (
                                  <div>
                                    <span
                                      style={{
                                        backgroundColor: "#1265C5",
                                        padding: "5px 10px",
                                        color: "white",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setSelectedOrderItemId(
                                          row.delivery_show_id,
                                        );
                                        setOpenModal(true);
                                      }}
                                    >
                                      Re-Assign
                                    </span>
                                  </div>
                                ) : (
                                  value || "--"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="invoice-image-modal"
        aria-describedby="invoice-image-preview"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <button
            onClick={() => setOpenModal(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">
            <h4>Do you want to assign this order to a different rider?</h4>
          </h3>
          <hr />
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleReallocate}
            >
              Re-Allocate
            </Button>
          </Box>
          <hr />
        </Box>
      </Modal>
    </>
  );
}
